<template>
  <form ref="form" @submit.prevent="$emit('submit', $refs.form)">
      <h2>{{ formTitle }}</h2>
      <div class='non-field-errors'>
         <errors :errors="errors"/>
      </div>
      <slot></slot>
      <save-continue-btns
         :back-route="backRoute"
         @save-and-continue="$emit('save-and-continue', $refs.form)"
      />
  </form>
</template>

<script>
import Errors from '@/components/molecules/Login/Errors'
import SaveContinueBtns from '@/components/molecules/Home/Plan/SaveContinueBtns';

export default {
   name: 'plan-form-wrapper',
   components: {
      SaveContinueBtns,
      Errors,
   },
   props: {
      formTitle: {
         type: String,
         required: true,
      },
      backRoute: {
         required: true,
         validator: route => typeof(route.name)==='string',
      },
      errors: {
         type: Array,
         required: true,
      }
   },
}
</script>

<style lang="scss" scoped>
form {
   font-family: $primary-font;
   color: $font-color;
   padding: 1em;
   .non-field-errors {
      @include flexCenter();
   }
   .inline-form-group
   {
      display: flex;
      > * {
         flex: 1;
         margin-right: 0.4em;
         &:last-child {
            margin-right: 0;
         }
      }
   }
}
</style>
